import React from "react";
import PropTypes from "prop-types";
import { Box } from "@mui/material";
import { AutoAwesomeOutlined as MRLIcon } from "@mui/icons-material";
import { colors, borderRadiusPx } from "../../../../../theme";
import { NoData, CommonButton } from "../../../../Components/ui";

const MegaLotteryEmptyState = ({ onReset, hasActiveFilters = false }) => {
  return (
    <Box
      sx={{
        bgcolor: colors.dashboard.cardBg,
        borderRadius: borderRadiusPx.xl,
        border: `1px solid ${colors.dashboard.cardBorder}`,
        p: { xs: 4, md: 6 },
        textAlign: "center",
        my: 3,
      }}
    >
      <NoData
        icon={<MRLIcon sx={{ fontSize: 36, color: colors.emerald[600] }} />}
        title={hasActiveFilters ? "No Matching MegaBET Games Found" : "No Active MegaBET Lotteries !"}
        subtitle={
          hasActiveFilters
            ? "Try adjusting your search terms or clearing your filters to discover open MegaBET games."
            : "There are currently no active MegaBET lotteries open. Please check back shortly or explore other lottery games!"
        }
        paper={false}
      />
      {hasActiveFilters && onReset && (
        <Box sx={{ mt: 2 }}>
          <CommonButton
            variant="primary"
            size="small"
            onClick={onReset}
            label="Reset Search Filters"
            sx={{
              bgcolor: colors.emerald[600],
              "&:hover": { bgcolor: colors.emerald[700] },
            }}
          />
        </Box>
      )}
    </Box>
  );
};

MegaLotteryEmptyState.propTypes = {
  onReset: PropTypes.func,
  hasActiveFilters: PropTypes.bool,
};

export default MegaLotteryEmptyState;
